exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-block {\n  background-color: #F5F6Fb;\n  padding: 0px 5%;\n}\n\n.nav-block > li {\n  flex: auto;\n  margin: 50px 0px 35px 0px;\n}\n", ""]);

// exports
